module.exports = "/_next/static/images/78c3e5123720db0d4dfd5f4df831c520-ppf-xs.png.webp";